var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.804 30.6177L10.2207 30.6315C7.01237 30.6344 4.38518 28.0124 4.38153 24.804L4.36768 10.2207C4.36476 7.01237 6.98685 4.38518 10.1952 4.38153L24.7785 4.36768C27.9868 4.36476 30.614 6.98685 30.6177 10.1952L30.6315 24.7785C30.6352 27.9876 28.0124 30.6148 24.804 30.6177Z",
    fill: "url(#paint0_radial_94_110)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.804 30.6177L10.2207 30.6315C7.01237 30.6344 4.38518 28.0124 4.38153 24.804L4.36768 10.2207C4.36476 7.01237 6.98685 4.38518 10.1952 4.38153L24.7785 4.36768C27.9868 4.36476 30.614 6.98685 30.6177 10.1952L30.6315 24.7785C30.6352 27.9876 28.0124 30.6148 24.804 30.6177Z",
    fill: "url(#paint1_radial_94_110)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 22.6042C14.6861 22.6042 12.3958 20.3146 12.3958 17.5C12.3958 14.6855 14.6861 12.3959 17.4999 12.3959C20.3138 12.3959 22.6041 14.6855 22.6041 17.5C22.6041 20.3146 20.3138 22.6042 17.4999 22.6042ZM17.4999 13.8542C15.4896 13.8542 13.8541 15.4897 13.8541 17.5C13.8541 19.5104 15.4896 21.1459 17.4999 21.1459C19.5102 21.1459 21.1458 19.5104 21.1458 17.5C21.1458 15.4897 19.5102 13.8542 17.4999 13.8542Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 13.125C23.5728 13.125 24.0625 12.6353 24.0625 12.0312C24.0625 11.4272 23.5728 10.9375 22.9688 10.9375C22.3647 10.9375 21.875 11.4272 21.875 12.0312C21.875 12.6353 22.3647 13.125 22.9688 13.125Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8749 26.9792H13.1249C10.3111 26.9792 8.02075 24.6896 8.02075 21.875V13.125C8.02075 10.3105 10.3111 8.02087 13.1249 8.02087H21.8749C24.6888 8.02087 26.9791 10.3105 26.9791 13.125V21.875C26.9791 24.6896 24.6888 26.9792 21.8749 26.9792ZM13.1249 9.47921C11.1146 9.47921 9.47909 11.1147 9.47909 13.125V21.875C9.47909 23.8854 11.1146 25.5209 13.1249 25.5209H21.8749C23.8852 25.5209 25.5208 23.8854 25.5208 21.875V13.125C25.5208 11.1147 23.8852 9.47921 21.8749 9.47921H13.1249Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_94_110",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1312 30.6505) scale(32.7389)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_94_110",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.59393 4.03977) scale(21.7386 14.4845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1b178ebe.svg";
export { ForwardRef as ReactComponent };